// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent/CustomEvent
var CustomEvent = function(event, params) {
  params = params || {
    bubbles: false,
    cancelable: false,
    detail: undefined
  };
  var evt = document.createEvent("CustomEvent");
  evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
  return evt;
};

CustomEvent.prototype = window.Event.prototype;
if (!window.CustomEvent) {
  window.CustomEvent = CustomEvent;
}

Number.isNaN =
  Number.isNaN ||
  function(value) {
    return typeof value === "number" && isNaN(value);
  };

// eslint-disable-next-line no-extend-native
String.prototype.hashCode = function() {
  var i, chr;
  var hash = 0;
  if (this.length === 0) return hash;
  for (i = 0; i < this.length; i++) {
    chr = this.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash > 0 ? hash : -hash;
};



// WEBPACK FOOTER //
// ./src/utils/polyfill.js